import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12.694 17.2272C12.9913 17.5156 12.9987 17.9904 12.7103 18.2877C12.4219 18.5851 11.9471 18.5924 11.6498 18.304L5.46227 12.304C5.31659 12.1628 5.23437 11.9685 5.23437 11.7656C5.23437 11.5627 5.31659 11.3685 5.46227 11.2272L11.6498 5.2272C11.9471 4.93885 12.4219 4.94615 12.7103 5.24351C12.9987 5.54088 12.9913 6.0157 12.694 6.30405L7.83517 11.0156L18.0156 11.0156C18.4298 11.0156 18.7656 11.3514 18.7656 11.7656C18.7656 12.1798 18.4298 12.5156 18.0156 12.5156L7.83517 12.5156L12.694 17.2272Z',
                    fill: '#A7ABC3',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const LeftLineOutlined = React.forwardRef(IconComponent);
LeftLineOutlined.displayName = 'LeftLineOutlined';

export { LeftLineOutlined };
